import { Slider } from '@mui/material';

// -- type definitions --

export interface LineThicknessSliderProps {
  value: number;
  onChange: (value: number) => void;
  min?: number;
  max?: number;
  step?: number;
}

// -- main component --

export function LineThicknessSlider({
  value,
  onChange,
  min = 1,
  max = 10,
  step = 0.5,
}: LineThicknessSliderProps) {
  return (
    <Slider
      value={value}
      onChange={(_, nextValue) => onChange(nextValue as number)}
      min={min}
      max={max}
      step={step}
      size="small"
      sx={{ width: '100%' }}
    />
  );
}
